// Default heightmap URL - imported so Vite includes it in the build
import heightmapUrl from '../assets/heightmap_512x512.png';
export const DEFAULT_HEIGHTMAP_URL = heightmapUrl;

// Parameters object - all configurable game settings
export const params = {
  // Heightmap
  terrainColor: '#8a8f9a',
  scale: 8.0,
  tileSize: 44,
  tilesX: 3,
  tilesZ: 3,
  // Particles
  pointSize: 0.08,
  jitter: 0.02,
  hoverRadius: 1.6,
  hoverStrength: 0.8,
  hoverSnap: 2.0,
  hoverColor: '#ffcc55',
  cols: 200,
  rows: 200,
  // Mask
  maskRadius: 8.8,
  minMaskRadius: 6.0,
  maxMaskRadius: 16.0,
  maskFeather: 4.9,
  // Animation
  scrollSpeed: 3.0,
  maxSpeed: 10.0,
  animateScroll: true,
  // Camera
  camYaw: 0,
  camPitch: -41,
  camFov: 75,
  minFov: 75,
  maxFov: 95,
  fovEasing: 1.5,  // how quickly FOV responds to speed changes (lower = slower, more "pressed into seat")
  camHeight: 3.0,
  camZ: 5.4,
  // Fog
  fogEnabled: true,
  fogColor: '#0e0f13',
  fogStart: 1,
  fogEnd: 34,
  // Camera modes: 'chase', 'topdown'
  cameraMode: 'chase',
  chaseCamDistance: 3.3,
  chaseCamHeight: 0.8,
  chaseCamAltitude: 1.5,
  topCamHeight: 7.0,
  // Airplane
  airplaneEnabled: true,
  airplaneSpeed: 3,
  airplaneMaxOffset: 5.5,
  airplaneVertSpeed: 2,
  airplaneAltitudeRange: 4.6,
  airplaneHeight: -2.5,
  airplaneSize: 0.4,
  airplaneDistance: 3.5,
  // Hover highlights
  mouseHoverEnabled: false,
  airplaneHoverEnabled: false,
  airplaneHoverRadius: 5.0,
  airplaneColorSafe: '#00dfff',   // cyan when high/safe
  airplaneColorDanger: '#ff0000', // red when low/danger
  // Strafe settings
  strafeSpeed: 1.0,
  strafeEasing: 2.0,
  maxStrafe: 8.0,
  // Dust wake effect - particles react to low-flying fast airplane
  dustWakeEnabled: true,
  dustWakeRadius: 1.8,           // how far the dust effect reaches horizontally
  dustWakeHeight: 0.15,          // how much particles depress (subtle)
  dustWakeSpeedThreshold: 5.0,   // minimum speed to trigger dust
  dustWakeClearanceMax: 1.2,     // max altitude for dust effect
  dustWakeColor: '#ff8800',      // orange dust color
  dustWakeTrailLength: 18.0,     // how far the color trail extends behind (long trail)
  // R key state (0: default, 1: highlight, 2: permanent ring)
  rKeyState: 2,
  // Audio-reactive terrain
  beatReactAmplitude: 15.0, // how many world units the scale modulates at full energy (terrain base scale is 8.0, so loud music goes to ~23)
};

// Helper functions
export const degToRad = (d) => d * Math.PI / 180;
export const clampPitchDeg = (p) => Math.max(-89, Math.min(89, p));

export function clampPowerOfTwo(n) {
  return Math.max(2, Math.min(2048, Math.floor(n)));
}
